// extracted by mini-css-extract-plugin
module.exports = {"detailsColumn":"ThemeForm_detailsColumn__1-6da","previewColumn":"ThemeForm_previewColumn__2RbzX"};